import React from 'react';

import S from 'app/features/landing/productComparison/components/icons/SuperFanProductIcon.styled';

const SuperFanProductIcon = () => (
  <S.SuperFanProductIcon title="SuperFan" xmlns="http://www.w3.org/2000/svg">
    <path d="M32.84 25.84l-9.11-14.09-8.98 14.09L0 19.4 7.64 45.1h32.31l7.64-25.71-14.75 6.44zm-17.02 3.52l7.92-12.43 8.03 12.43 11.42-4.99-5.33 17.94H9.73L4.4 24.37l11.42 5z" />
    <path d="M6.8 23.66l4.9-7.8 7.9 4.83-1.46 2.39-5.53-3.4-3.44 5.46zm21.18-2.97l7.9-4.84 4.9 7.8-2.37 1.5-3.43-5.46-5.53 3.39zM23.74 3a5.54 5.54 0 00-5.57 5.51c0 3.05 2.5 5.52 5.57 5.52 3.07 0 5.56-2.47 5.56-5.52S26.8 3 23.74 3zm0 2.8a2.74 2.74 0 012.77 2.71c0 1.5-1.24 2.72-2.77 2.72a2.74 2.74 0 01-2.77-2.72c0-1.5 1.23-2.71 2.77-2.71zm.11 21.09a5.54 5.54 0 00-5.57 5.51c0 3.05 2.5 5.51 5.57 5.51a5.54 5.54 0 005.57-5.51c0-3.05-2.5-5.51-5.57-5.51zm0 2.8a2.74 2.74 0 012.77 2.71c0 1.5-1.23 2.71-2.77 2.71a2.74 2.74 0 01-2.77-2.71c0-1.5 1.24-2.71 2.77-2.71z" />
  </S.SuperFanProductIcon>
);

export default SuperFanProductIcon;
